import { api } from "./api";

export const GET_ALL_CONTRACTS = async () => {
    const { data } = await api.get("/contracts")
    return data.contracts || [];
}

export const GET_CONTRACT = async (id: string) => {
    const { data } = await api.get(`/contracts/${id}`)
    return data;
}

export const DELETE_CONTRACT = async (id: string) => {
    const { data } = await api.delete(`/contracts/${id}`)
    return data;
}

export const CREATE_CONTRACT = async (params: any) => {
    const { data } = await api.post(`/contracts`, params)
    return data;
}

export const UPDATE_CONTRACT = async (id: string, params: any) => {
    const { data } = await api.patch(`/contracts/${id}`, params)
    return data;
}

